// Constants and default values for treatment report editor

export const REPORT_STATUSES = [
  { value: 'draft', label: 'Draft' },
  { value: 'completed', label: 'Completed' },
  { value: 'sent', label: 'Sent' }
];

export const DEFAULT_FORM_DATA = {
  customer_id: '',
  job_id: '',
  appointment_id: '',
  report_number: '',
  service_date: '',
  technician_id: '',
  status: 'draft',
  job_category_id: '',
  category_path: '',
  treatment_areas: [],
  treatment_methods: '',
  pest_findings: '',
  products_used: '',
  recommendations: '',
  follow_up_required: false,
  follow_up_date: '',
  site_plan_url: '',
  photos: [],
  line_items: [],
  subtotal: 0,
  tax_rate: 20.00,
  tax_amount: 0,
  total_amount: 0,
  customer_signature_url: '',
  technician_signature_url: '',
  customer_name_signed: '',
  signature_date: '',
  // Treatment contact fields (prefilled from customer)
  treatment_contact_name: '',
  treatment_contact_company: '',
  treatment_contact_email: '',
  treatment_contact_phone: '',
  // Treatment address fields (prefilled from job)
  treatment_address_line1: '',
  treatment_address_line2: '',
  treatment_address_city: '',
  treatment_address_state: '',
  treatment_address_postcode: '',
  treatment_address_country: 'United Kingdom',
  use_customer_address: false
};

export const SEARCH_CONFIG = {
  CUSTOMER_MIN_LENGTH: 2,
  SERVICE_MIN_LENGTH: 2,
  NOTIFICATION_TIMEOUT: 4000
};

export const FORM_FIELD_CLASSES = {
  input: "w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-pest-blue focus:border-pest-blue hover:border-gray-400 transition-colors",
  textarea: "w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-pest-blue focus:border-pest-blue hover:border-gray-400 transition-colors resize-none",
  select: "w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-pest-blue focus:border-pest-blue hover:border-gray-400 transition-colors",
  readOnly: "w-full px-4 py-3 border-2 border-gray-300 rounded-lg bg-gray-50"
};

export const BUTTON_CLASSES = {
  primary: "px-6 py-3 bg-gradient-to-r from-pest-blue to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white rounded-lg transition-all duration-200 font-semibold shadow-lg hover:shadow-xl disabled:opacity-50",
  secondary: "px-6 py-3 text-gray-700 bg-gray-100 hover:bg-gray-200 border-2 border-gray-300 hover:border-gray-400 rounded-lg transition-all duration-200 font-medium",
  danger: "text-gray-400 hover:text-red-600 transition-colors"
};